import http from './utils';
import { prefix } from './constants';

type TApiFunction<TPayload = any, TResponse = any> = (
  payload: TPayload,
) => Promise<TResponse>;

/**
 * UGC Trends 接口集合
 *
 * 接口文档：src/pages/marketing/specs/UGC社媒热门创意详情页/api/
 */
export const getUgcTrendsStats: TApiFunction = payload => {
  return http({
    url: `${prefix}/ugc_trends/tab_stats`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getUgcTrendsList: TApiFunction = payload => {
  return http({
    url: `${prefix}/ugc_trends/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getUgcTrendDetail: TApiFunction = payload => {
  return http({
    url: `${prefix}/ugc_trends/detail`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getUgcTrendRelatedVideos: TApiFunction = payload => {
  return http({
    url: `${prefix}/ugc_trends/related_videos`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};
